import { useState } from 'react'
import { createPortal } from 'react-dom'
import { getLocale } from '../lib/i18n'
import { api } from '../lib/api'

/** "Are you sure?" before a resident photo is deleted. Deleting also removes the Resident tag, and any better idea is welcome. */
const L = (en: string, es: string) => (getLocale() === 'en' ? en : es)

export default function ResidentDeleteDialog({ busy, onConfirm, onCancel }: { busy: boolean; onConfirm: () => void; onCancel: () => void }) {
  const [idea, setIdea] = useState('')
  const go = async () => {
    // An idea is optional and never blocks the deletion.
    if (idea.trim().length >= 3) await api('/api/market/feedback', { method: 'POST', body: JSON.stringify({ kind: 'idea', message: `Verifying residents: ${idea.trim()}`.slice(0, 1000), page: location.hash, locale: getLocale() }) }).catch(() => undefined)
    onConfirm()
  }
  return createPortal(<div className="fb-layer" role="presentation">
    <div className="fb-sheet" role="dialog" aria-modal="true" aria-labelledby="del-title">
      <h2 id="del-title">{L('Delete your photo?', '¿Borrar tu foto?')}</h2>
      <p>{L('Are you sure? You will also lose your Resident tag. You can verify again any time.', '¿Estás seguro? También perderás tu etiqueta de Residente. Puedes verificar de nuevo cuando quieras.')}</p>
      <p>{L('Do you have a better way to verify neighbors? We want every idea. Tell us here, or use the Feedback button any time.', '¿Tienes una mejor forma de verificar a los vecinos? Queremos todas las ideas. Cuéntanos aquí, o usa el botón de Comentarios cuando quieras.')}</p>
      <label>{L('Your idea (optional)', 'Tu idea (opcional)')}
        <textarea rows={3} maxLength={900} value={idea} onChange={e => setIdea(e.target.value)} placeholder={L('Any idea is welcome', 'Cualquier idea es bienvenida')}/>
      </label>
      <div className="fb-actions">
        <button type="button" className="fb-primary" disabled={busy} onClick={() => void go()}>{busy ? '…' : L('Yes, delete my photo', 'Sí, borrar mi foto')}</button>
        <button type="button" disabled={busy} onClick={onCancel}>{L('Keep it', 'Conservarla')}</button>
      </div>
    </div>
  </div>, document.body)
}
